const MenuOption = ({ label, icon, onButtonClick }) => {
    const handleClick = () => {
        const recoveredData = label;
        onButtonClick(recoveredData);
    }

    return (
        <li>
            <button onClick={handleClick} className="w-4/5 p-2 flex items-center justify-left mx-auto text-white bg-neutral-950 font-inter font-medium leading-tight hover:text-orange-600 hover:bg-orange-300 transition-colors duration-200 rounded-lg changeColor hover:opacity-90 text-xl">
                {icon && <span className="mr-2">{icon}</span>}
                {label}
            </button>
        </li>
    );
};

export default MenuOption;